import React from "react";
import { Outlet } from "react-router-dom";
import i18n from "i18next";

export function UnloggedLayout() {
  return (
    <div className={"h-screen w-screen flex items-center justify-center"}>
      <a
        href={"https://lancerkit.com"}
        className={"font-bold fixed top-4 left-4 hidden md:flex"}
      >
        Lancerkit
      </a>

      <div className={"fixed top-4 right-4 flex gap-3"}>
        <a
          href="#"
          className={"hover:underline"}
          onClick={() => {
            window.localStorage.language = "fr";
            return i18n.changeLanguage("fr");
          }}
        >
          FR
        </a>
        <a
          href="#"
          className={"hover:underline"}
          onClick={() => {
            window.localStorage.language = "en";
            return i18n.changeLanguage("en");
          }}
        >
          EN
        </a>
      </div>

      <div
        className={"flex mx-auto w-full gap-3 items-center"}
        style={{ maxWidth: 1000 }}
      >
        <div
          className={"flex-grow flex flex-col gap-3 hidden md:flex"}
          style={{ maxWidth: 500 }}
        >
          <p className={"text-2xl font-bold display text-blue-500"}>
            Say goodbye to paperwork
          </p>
          <p className={"text-3xl font-bold display text-blue-900"}>
            Lancerkit is the accounting document collection system that you
            need.
          </p>
        </div>

        <div
          className={
            "overflow-y-auto overflow-x-hidden max-h-screen p-3 max-w-screen"
          }
        >
          <div
            className={" bg-blue-50 p-7 flex rounded-xl flex-col gap-3"}
            style={{ minWidth: 400 }}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
